var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paypal-buttons"},[_c('div',{attrs:{"id":"paypal-button-container"}}),(!_vm.amount || _vm.disabled || _vm.loading)?_c('v-overlay',{staticClass:"disabled-buttons-overlay select-none",attrs:{"color":"surface","opacity":"0.4","absolute":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }